export default {
  checkedTutorials: null,
};



// WEBPACK FOOTER //
// ./src/app/tutorials/store/state.js